import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class UserPerformanceService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getUserPerformance(payload): Observable<any> {
    return this.httpHelperService.get(
      `/sales/my-performance?userId=${payload.userId}&agentCode=${payload.agentCode}`,
    );
  }

  public getPageAccess(userId): Observable<any> {
    return this.httpHelperService.get(`/users/page-access?userId=${userId}`);
  }
}
